"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Details/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');
var _reacthookform = require('react-hook-form');








var _myRelations = require('shared/selectors/myRelations');
var _peers = require('shared/selectors/peers');
var _user = require('shared/selectors/user');




var _broadcastCampaign = require('shared/validation/broadcastCampaign');
var _hooks = require('web/services/hooks');
var _useBroadcastForm = require('./helpers/useBroadcastForm'); var _useBroadcastForm2 = _interopRequireDefault(_useBroadcastForm);
var _const = require('./helpers/const');





var _Form = require('web/components/Form');
var _MoreInfoToggle = require('web/components/SecureText/MoreInfoToggle'); var _MoreInfoToggle2 = _interopRequireDefault(_MoreInfoToggle);
var _SenderPickerController = require('./SenderPickerController'); var _SenderPickerController2 = _interopRequireDefault(_SenderPickerController);
var _MessageTypeController = require('./MessageTypeController'); var _MessageTypeController2 = _interopRequireDefault(_MessageTypeController);
var _Spinner = require('web/components/Spinner');
var _WizardFrame = require('../WizardFrame');
var _helpers = require('../helpers');
var _defaultTeam = require('../../defaultTeam');



// D10: once a message was sent or a consent request went out, team, sender
// and type describe how it went out, so they can't change. A failed send
// doesn't lock them. The server applies the same rule.
const areDetailsLocked = (s) =>
  s.completed + (_nullishCoalesce(s.awaiting_consent, () => ( 0))) > 0










const DetailsForm = ({
  campaign,
  isCreating,
  onCancel,
  onSubmit,
  onDirtyChange,
}) => {
  const {
    teamsList,
    teamEntitiesMap,
    defaultTeamKey,
  } = _hooks.useAppSelector.call(void 0, selectTeamsState, _reactredux.shallowEqual)

  // F2: a new campaign is sent by whoever creates it, unless they pick someone else.
  const myUserKey = _nullishCoalesce(_hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey), () => ( null))

  const { register, resetField, control, handleSubmit, formState } = _useBroadcastForm2.default.call(void 0, {
    name: _nullishCoalesce(_optionalChain([campaign, 'optionalAccess', _ => _.Name]), () => ( '')),
    teamKey: _optionalChain([campaign, 'optionalAccess', _2 => _2.TeamKey]) || defaultTeamKey || '',
    senderKey: _nullishCoalesce(_nullishCoalesce(_optionalChain([campaign, 'optionalAccess', _3 => _3.SenderKey]), () => ( myUserKey)), () => ( '')),
    messageType: _nullishCoalesce((_optionalChain([campaign, 'optionalAccess', _4 => _4.MessageType]) ), () => ( _broadcastCampaign.MessageType.SecureSMS)),
    messageDelay: _nullishCoalesce(_optionalChain([campaign, 'optionalAccess', _5 => _5.MessageDelay]), () => ( _broadcastCampaign.DEFAULT_MESSAGE_DELAY_MS)),
  })

  const isLocked = !!campaign && areDetailsLocked(campaign.Stats)
  const messageType = _reacthookform.useWatch.call(void 0, { control, name: 'messageType' })
  const [error, setError] = _react.useState(null)

  const onProceed = _react.useCallback.call(void 0, 
    (data) => {
      setError(null)
      return onSubmit({
        Name: data.name,
        TeamKey: data.teamKey ,
        SenderKey: data.senderKey ,
        MessageType: data.messageType,
        // Verbatim: presets are whole seconds, and a saved odd value stays
        // as it was (review R800-37).
        MessageDelay: data.messageDelay,
      }).catch((e) => setError(_helpers.errorText.call(void 0, 
        e,
        campaign ? "Couldn't save the campaign" : "Couldn't create the campaign",
      )))
    },
    [onSubmit, campaign],
  )

  const { isValid, isSubmitting, isDirty, errors } = formState
  _react.useEffect.call(void 0, () => { _optionalChain([onDirtyChange, 'optionalCall', _6 => _6(isDirty)]) }, [isDirty, onDirtyChange])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_WizardFrame.StepBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
        , _react2.default.createElement('div', { className: "broadcast-wizard--card broadcast-wizard--card-pad" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
          , _react2.default.createElement(_Form.InputSection, {
            title: "Campaign Name" ,
            autoFocus: true,
            placeholder: "E.g. Appointment Reminders"  ,
            inputProps: register('name'),
            errorMessage: _optionalChain([errors, 'access', _7 => _7.name, 'optionalAccess', _8 => _8.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
          )
          ,  isLocked && campaign
            ? _react2.default.createElement(LockedDetails, { campaign: campaign, teamEntitiesMap: teamEntitiesMap, __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}} )
            : (
                _react2.default.createElement(_react2.default.Fragment, null
                  , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
                    , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Team", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
                      , _react2.default.createElement(_Form.TeamPickerController, {
                        name: "teamKey",
                        control: control,
                        teamsList: teamsList,
                        teamEntitiesMap: teamEntitiesMap, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
                      )
                    )
                    , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Sender", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
                      , _react2.default.createElement(_SenderPickerController2.default, {
                        name: "senderKey",
                        teamKeyName: "teamKey",
                        control: control,
                        resetField: resetField,
                        teamEntitiesMap: teamEntitiesMap,
                        defaultSenderKey: myUserKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
                      )
                    )
                  )
                  , _react2.default.createElement(_Form.InputSectionWrapper, {
                    title: "Message Type" ,
                    titleAccessory: _react2.default.createElement(_MoreInfoToggle2.default, { isAlert: messageType === _broadcastCampaign.MessageType.InsecureSMS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}

                    , _react2.default.createElement(_MessageTypeController2.default, {
                      name: "messageType",
                      control: control,
                      options: _const.messageTypeOptions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
                    )
                  )
                )
              )
          
          ,  isLocked && (
            _react2.default.createElement('p', { className: "broadcast-wizard--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}, "Team, sender and message type are locked because this campaign has started sending."

            )
          )
          ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}},  error ) 
        )
      )
      , _react2.default.createElement(_WizardFrame.StepFooter, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}
        , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}, "Cancel")
        , _react2.default.createElement(_WizardFrame.WizardFooterNote, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 162}} )
        , _react2.default.createElement(_Form.Button, {
          isLoading: isSubmitting,
          isDisabled: isSubmitting || !isValid,
          onClick: handleSubmit(onProceed), __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}

          ,  isCreating ? 'Continue' : 'Save' 
        )
      )
    )
  )
}

/* D10: once a message is sent, team, sender and type are shown, not edited.
 * The form keeps their saved values, so a save sends them unchanged. */
const LockedDetails = ({
  campaign,
  teamEntitiesMap,
}) => {
  const senderName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_peers.selectUserByKey.call(void 0, state, campaign.SenderKey), 'optionalAccess', _9 => _9.Name]), () => ( '')))
  const teamName = _nullishCoalesce(_optionalChain([teamEntitiesMap, 'access', _10 => _10[campaign.TeamKey], 'optionalAccess', _11 => _11.wrappedEntity, 'optionalAccess', _12 => _12.Name]), () => ( ''))
  const typeLabel = _nullishCoalesce(_optionalChain([_const.messageTypeOptions, 'access', _13 => _13.find, 'call', _14 => _14(o => o.value === campaign.MessageType), 'optionalAccess', _15 => _15.label]), () => ( campaign.MessageType))
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}
        , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Team", __self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}
          , _react2.default.createElement('div', { className: "broadcast-wizard--locked-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}},  teamName || '—' )
        )
        , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Sender", __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}
          , _react2.default.createElement('div', { className: "broadcast-wizard--locked-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}},  senderName || '—' )
        )
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, {
        title: "Message Type" ,
        titleAccessory: _react2.default.createElement(_MoreInfoToggle2.default, { isAlert: campaign.MessageType === _broadcastCampaign.MessageType.InsecureSMS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}

        , _react2.default.createElement('div', { className: "broadcast-wizard--locked-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 198}},  typeLabel )
      )
    )
  )
}







const selectTeamsState = (state) => {
  const {
    teamsList,
    entitiesMap: teamEntitiesMap,
  } = _myRelations.selectMyPhoneTeamEntities.call(void 0, state) 



  return {
    teamsList,
    teamEntitiesMap,
    defaultTeamKey: _defaultTeam.selectDefaultCampaignTeamKey.call(void 0, state),
  }
}

/* The team pickers need my phone teams loaded (and the campaign's team among
 * them), which a cold load of the wizard doesn't have yet. */
const CampaignDetails = props => {
  const { campaign, onCancel } = props
  const status = _hooks.useAppSelector.call(void 0, state => {
    const { entitiesMap } = _myRelations.selectMyPhoneTeamEntities.call(void 0, state) 
    if (!Object.keys(entitiesMap).length) return 'loading'
    if (!campaign || entitiesMap[campaign.TeamKey]) return 'ready'
    // Locked details show as text, so no picker needs the team.
    return areDetailsLocked(campaign.Stats) ? 'ready' : 'not-member'
  })
  if (status === 'loading') {
    return (
      _react2.default.createElement(_WizardFrame.StepBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
        , _react2.default.createElement('div', { className: "broadcast-wizard--loading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}, _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 239}} ))
      )
    )
  }
  if (status === 'not-member') {
    return (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement(_WizardFrame.StepBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}
          , _react2.default.createElement('div', { className: "broadcast-wizard--card broadcast-wizard--card-pad" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}
            , _react2.default.createElement('p', { className: "broadcast-recipients--intro", __self: this, __source: {fileName: _jsxFileName, lineNumber: 248}}, "Only members of this campaign's team can change its details."

            )
          )
        )
        , _react2.default.createElement(_WizardFrame.StepFooter, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}
          , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}, "Cancel")
        )
      )
    )
  }
  return _react2.default.createElement(DetailsForm, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}} )
}

exports. default = _react.memo.call(void 0, CampaignDetails)
